import * as React from 'react';
import * as styles from './styles.css';

import { SectionOfQuestions } from '../../../SeqtionOfQuestions';
import { Explain } from '../../../Explain';
import { Valuation } from '../../../Valuation';
// import { ValuationHeaderContainer } from '../../../../containers/ValuationHeaderContainer';
import { ValuationFiltersContainer } from '../../../../containers/ValuationFiltersContainer';

export const DesktopView = () => {
  return (
    <div className={styles['information']}>
      <ValuationFiltersContainer />
      <div className={styles['questions']}>
        <Explain />
        <SectionOfQuestions />
      </div>
      <Valuation />
    </div>
  );
};
